<template>
  <div class="distributor-box">
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002327')" prop="name">
              <Input v-model.trim="pageParams.name" :placeholder="$t('key1002597')" clearable></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002433')" prop="ymsDeliveryPlaceId">
              <Select v-model="pageParams.ymsDeliveryPlaceId">
                <Option v-for="item in placeOfShipmentList" :key="item.ymsDeliveryPlaceId" :value="item.ymsDeliveryPlaceId">{{ item.deliveryPlaceName }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002598')" prop="countryCode">
              <Select v-model="pageParams.countryCode" filterable>
                <Option v-for="item in countrysList" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--查看仓库详情弹窗-->
    <repositoryDetailsModal :countrysOriginalData="countrysOriginalData" ref="repositoryDetails"></repositoryDetailsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllCountrysData, getBatchDeliveryAreasName, getPlaceOfShipmentCountryData} from "@/utils/common";
import repositoryDetailsModal from "@/views/distributor/components/warehouseManage/repositoryDetailsModal.vue";


export default {
  name: 'repositoryList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        name: '',
        ymsDeliveryPlaceId: null,
        countryCode: null,
        pageNum: 1,
        pageSize: 15
      },
      placeOfShipmentList: [],
      countrysList: [],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000241'),
          key: 'name',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002585'),
          key: 'deliveryPlaceName',
          minWidth: 140,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002586'),
          key: 'countryCode',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let twoCode = params.row.countryCode || null;
            let text = '';
            if (v.countrysList.length > 0) {
              v.countrysList.map((item) => {
                if (item.twoCode === twoCode) {
                  text = item.name;
                }
              });
              return h('span', text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$refs['repositoryDetails'].initRepositoryDetailsData(params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      total: 0,
      countrysOriginalData: [],
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await getAllCountrysData().then((data) => {
          this.countrysOriginalData = data;
        });
        this.search();
      })();
    },
    // 重置按钮
    reset() {
      let v = this;
      if (v.$refs['pageParams']) {
        v.$refs['pageParams'].resetFields();
      }
      v.getList();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.total = 0;
      v.optionBtnWidth = [];
      v.tableData = [];
      v.getPlaceOfShipmentCountryList();
      if (v.getPermission('ymsDistributorWarehouse_query')) {
        v.axios.post(api.post_ymsDistributorWarehouse_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.total = data.total;
              let list = data.list || [];
              const ymsDeliveryPlaceIdList = list.map(item => item.ymsDeliveryPlaceId).filter(id => id);
              if (ymsDeliveryPlaceIdList.length > 0) {
                getBatchDeliveryAreasName(ymsDeliveryPlaceIdList).then((newData) => {
                  const nameMap = new Map(newData.map(ele => [ele.ymsDeliveryPlaceId, ele.deliveryPlaceName]));
                  list.forEach(item => {
                    if (nameMap.has(item.ymsDeliveryPlaceId)) {
                      item.deliveryPlaceName = nameMap.get(item.ymsDeliveryPlaceId);
                    }
                    item.name = item.aliasWarehouseName || item.name;
                  });
                  v.tableData = list;
                  v.updateTableDom('selection');
                });
              } else {
                v.tableData = list;
                v.tableLoading = false;
              }
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取发货地与国家信息数据
    getPlaceOfShipmentCountryList() {
      getPlaceOfShipmentCountryData().then((obj) => {
        let countryCodes = obj.countryCodes || [];
        this.placeOfShipmentList = obj.ymsDeliveryPlaces || [];
        this.countrysList = this.countrysOriginalData.filter((item) => {
          return countryCodes.includes(item.twoCode);
        });
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
  },
  components: {
    repositoryDetailsModal
  }
};
</script>

<style lang="less">

</style>
